module.exports = __webpack_public_path__ + "assets/img/image_313.eb23a5ee.png";